import React from "react";
import css from './CardETFsEducational.css'
import PropTypes from 'prop-types';

export default function CardETFsEducational(props) {

  return <div className={css.card}>
      <h3 className={[css.card__title, css.bottomDivider].join(" ")}>{props.title}</h3>
      <p className={css.card__content}>{props.body}</p>
      <div className={css.card__arrow}>
        <i className="fas fa-arrow-right"></i>
      </div>
      <a href={props.src} target="_blank" rel="noopener noreferrer">
        <span className={css.clickable}/>
      </a>
    </div>
}

CardETFsEducational.propTypes = {
    title: PropTypes.string,
    body: PropTypes.string,
    src: PropTypes.string
}
